module.exports = __webpack_public_path__ + "img/checklists.33dc2c6d.svg";